// extracted by mini-css-extract-plugin
module.exports = {"card":"PcDirection_card_2bQCp","title":"PcDirection_title_32Gaw","intro":"PcDirection_intro_28bnq"};